import {searchReportHTML, searchReport, searchReportById} from '../reports/reports.api';

// #region Globals
const CONTEXT_BASE_PATH = 'puerto/pdf';
const CONTEXT_BASE_HTML_PATH = 'puerto/html';
const CONTEXT_SINGLE_BASE_PATH = 'puerto/pdfindividual';
// #endregion

// #region Public functions
async function getMountainPortPdf(id) {
  return searchReportById(id, CONTEXT_SINGLE_BASE_PATH);
}
async function searchMountainPortPdf(searchParams = {}) {
  return searchReport(searchParams, CONTEXT_BASE_PATH);
}
async function searchMountainPortHtml(searchParams = {}) {
  return searchReportHTML(searchParams, CONTEXT_BASE_HTML_PATH);
}

// #endregion

// #region Private functions
// ...
// #endregion

export {
  getMountainPortPdf,
  searchMountainPortPdf,
  searchMountainPortHtml,
};
